<div id="background-img-login"></div>
<div class="card login-zone-size mx-auto">
	<article class="card-body">
		<h3 class="card-title text-center">
			<a
				role="button"
				href="https://www.isycare-technology.com"
				target="_blank"
				rel="noopener noreferrer"
			>
				<img
					id="logo-isycare"
					src="assets/img/logoIsycareTechnology.png"
					alt="Isycare Technology Logo"
					class="mb-3"
				/>
			</a>
			<p class="unselectable-text">
				Bienvenue sur <strong>Isyplanning</strong>
			</p>
		</h3>
		<form>
			<div class="mb-3">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text theme-main-color"
							><i class="bi bi-person-fill"></i
						></span>
					</div>
					<input
						type="text"
						name="login"
						class="form-control"
						placeholder="Adresse email"
						[(ngModel)]="username"
						required
					/>
				</div>
			</div>
			<div class="mb-3">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text theme-main-color"
							><i class="bi-key-fill"></i
						></span>
					</div>
					<input
						type="password"
						class="form-control"
						name="password"
						placeholder="Mot de passe"
						[(ngModel)]="password"
						passwordToggle
						required
					/>
				</div>
			</div>
			<div class="row mx-1">
				<button
					type="submit"
					class="btn theme-main-color-button btn-block"
					[disabled]="
						username === '' || password === '' || isTryingToLogin
							? 'disabled'
							: null
					"
					(click)="signIn()"
				>
					Se connecter
				</button>
			</div>

			<div *ngFor="let alert of alerts">
				<alert
					[type]="alert.type"
					[dismissible]="true"
					(onClosed)="onClosed(alert)"
					>{{ alert.msg }}</alert
				>
			</div>

			<p class="text-center mt-3">
				<a routerLink="/recovery">Mot de passe oublié?</a>
			</p>
			<p class="text-center mt-5">
				Êtes-vous un prescripteur ?
				<a routerLink="/prescriber/signup">Inscription</a>
			</p>
		</form>
	</article>
</div>
